import axios from 'axios';
import { API_BASE } from "../config/apiBase";

// Create a new instance of Axios
const api = axios.create({
  baseURL: API_BASE,
  timeout: 5000, // Set the request timeout if needed
  headers: {
    'Content-Type': 'application/json',
    // 'Authorization': `Bearer ${authToken}`,
  },
});

export default api;
